export class EncryptionKeys {
    'keys';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "keys",
            "baseName": "keys",
            "type": "Array<EncryptionKey>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EncryptionKeys.attributeTypeMap;
    }
    constructor() {
    }
}
